// https://vuex.vuejs.org/en/mutations.html

export default {
  refreshAdminProducts (state, products) {
    state.adminList = products
  },
  UpdateProduct (state, product) {
    var existingElementIndex
    state.adminList.some((el, index) => {
      if (el.uid === product.uid) {
        existingElementIndex = index
        return true
      }
    })
    if (existingElementIndex > -1) {
      state.adminList.splice(existingElementIndex, 1, product)
    } else {
      state.adminList.push(product)
    }
  },
  DeleteProduct (state, productUid) {
    var existingElementIndex
    state.adminList.some((el, index) => {
      if (el.uid === productUid) {
        existingElementIndex = index
        return true
      }
    })
    if (existingElementIndex > -1) {
      state.adminList.splice(existingElementIndex, 1)
    }
  },
}
